import { useService } from '@old/hooks/use-service';
import { useParams } from 'react-router';
import { SilobagNewEditForm } from '@old/features/silobags/silobag-forms/silobag-new-edit-form';
import { silobagDataDetailService } from '@old/services/domain/base/silobag/base/silobag-data-detail';

export function SilobagEditPage() {
  const { siloID } = useParams();

  const { isLoading, summary } = useService(silobagDataDetailService, {
    fetchOnMount: [{ query: siloID ?? 'id-not-found' }],
  });

  return <SilobagNewEditForm type="edit" parentFormData={summary!} isParentLoading={isLoading} />;
}
